import React from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryContact} from "@/service/contact.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {isNumber} from "lodash";
import {formatTime} from "@/helper/method";
import {useDrawerModal} from "@/store/global.c";

export const ViewContact = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: contactData, isLoading: contactLoading} = useQueryContact({id: drawerId!}, isNumber(drawerId))
    const contact = contactData?.data
    return <> <ResultWrapper isLoading={contactLoading} isEmpty={isEmpty(contact)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'姓名'} content={contact?.name}/>
                <GridItem title={'联系电话'} content={contact?.mobile}/>
                <GridItem title={'首要联系人'} content={contact?.firsted == 1 ? '是' : '否'}/>
                <GridItem title={'性别'} content={contact?.gender == 1 && '男' || contact?.gender == 2 && "女" || "未知"}/>
                <GridItem title={'客户名称'} content={contact?.customerName}/>
                <GridItem title={'业务人员'} content={contact?.creator}/>
                <GridItem title={'邮箱'} content={contact?.email}/>
                <GridItem title={'职位'} content={contact?.post}/>
                <GridItem title={'更新时间'} content={formatTime('D', contact?.updatedAt)}/>
                <GridItem title={'创建时间'} content={formatTime('D', contact?.createdAt)}/>
            </Grid>
        </Stack></ResultWrapper>
    </>
}